import React, { useLayoutEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Routes, Route } from "react-router-dom";
import PrivateRoute from './privateRoute';

import Login from "../pages/login";
import Register from "../pages/register";
import ForgotPassword from "../pages/forgot_password";
import ResetPassword from "../pages/reset_password";

import Dashboard from "../pages/dashboard";
import Profile from "../pages/profile";

import SaleSearch from "../pages/sale-search";
import SalesAddEdit from "../pages/sale-add.js";
import RefreshAndNewSale from "../pages/refresh-and-new-sale";
import CustomerSearch from "../pages/customer-search";
import CustomerAdd from "../pages/customer-add";
import ProductSearch from "../pages/product-search";
import ProductAdd from "../pages/product-add";
import CompanyAdd from "../pages/company-add";
import CompanySearch from "../pages/company-search";
import InvoiceTypeAdd from "../pages/invoicetype-add";
import InvoiceTypeSearch from "../pages/invoicetype-search";
import InvoiceView from "../pages/viewinvoice";
import TemplateDesigner from "../pages/template-designer";
import TemplateSearch from "../pages/template-search";

import AadeSaleSearchByMark from "../pages/aade-sale-search-bymark";
import CompanyIncomes from "../pages/company-incomes";

import PreSaleSearch from "../pages/pre-sale-search";
import Deductions from "../pages/company-deduction";
import ProductCategoryAdd from "../pages/product-category-add";
import ProductCategorySearch from "../pages/product-category-search";
import NotFound from '../pages/notfound';
import Swagger from "../pages/swagger";
import ShareScreenPage from "../pages/share-screen";
import PosTransactionSearch from "../pages/postransaction-search.js";
import RequestPaymentSearch from "../pages/requestpayment-search.js";

import TemplateComponent from "./templates/template-simple.component";
import Payment from "./payment.component.js";
import ChoosePackage from "./choose-package";
import StartYourSubscription from "../pages/startSubscription.js";
import OAuth2RedirectHandler from '../services/OAuth2RedirectHandler';

import StripePayment from "../pages/stripe-payment";
import PaymentStatus from "../pages/stripe-payment-complete";
import MainLayout from './layout/main-layout';
import useStore from "../hooks/useStore";

import Error from "../pages/error.js";
import ParochosForm from "../pages/parochos-form";

const MainRouter = (props) => {
    const { t } = useTranslation();
    const bootstrapped = useStore((state) => state.bootstrapped);

    if (!bootstrapped) return <div>Loading...</div>; 
    
    return (
        <Routes>
            <Route path="/login" element={<Login {...props} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/reset/:token" element={<ResetPassword />} />
            <Route path="/mydata/:invoiceUid" element={<InvoiceView />} />
            <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
            <Route path="/template" element={<TemplateComponent />} />
            <Route path="/checkout" element={<StripePayment />} />
            <Route path="/checkout/complete" element={<PaymentStatus />} />
            <Route path="/swagger" element={<Swagger />} />
            <Route path="/choosepackage" element={<ChoosePackage />} />
            <Route path="/startSubscription" element={<StartYourSubscription />} />

            {/* Private Routes */}
            <Route element={<PrivateRoute />}>
                <Route path="/" element={<MainLayout><Dashboard /></MainLayout>} />
                <Route path="home" element={<MainLayout><Dashboard /></MainLayout>} />
                <Route path="profile" element={<MainLayout><Profile /></MainLayout>} />
                <Route path="sale/:id" element={<MainLayout><SalesAddEdit key="edit" /></MainLayout>} />
                <Route path="sale" element={<MainLayout><SalesAddEdit key="new" /></MainLayout>} />
                <Route path="newsale" element={<MainLayout><RefreshAndNewSale /></MainLayout>} />
                <Route path="sales" element={<MainLayout><SaleSearch /></MainLayout>} />
                <Route path="presales" element={<MainLayout><PreSaleSearch /></MainLayout>} />
                <Route path="incomes" element={<MainLayout><CompanyIncomes /></MainLayout>} />
                <Route path="customer" element={<MainLayout><CustomerAdd /></MainLayout>} />
                <Route path="customer/:id" element={<MainLayout><CustomerAdd /></MainLayout>} />
                <Route path="customers" element={<MainLayout><CustomerSearch /></MainLayout>} />
                <Route path="usercompany" element={<MainLayout><CompanyAdd /></MainLayout>} />
                <Route path="usercompany/:id" element={<MainLayout><CompanyAdd /></MainLayout>} />
                <Route path="usercompanies" element={<MainLayout><CompanySearch /></MainLayout>} />
                <Route path="invoicetype" element={<MainLayout><InvoiceTypeAdd /></MainLayout>} />
                <Route path="invoicetype/:id" element={<MainLayout><InvoiceTypeAdd /></MainLayout>} />
                <Route path="invoicetypes" element={<MainLayout><InvoiceTypeSearch /></MainLayout>} />
                <Route path="designer/:id" element={<MainLayout><TemplateDesigner /></MainLayout>} />
                <Route path="templates" element={<MainLayout><TemplateSearch /></MainLayout>} />
                <Route path="productcategory" element={<MainLayout><ProductCategoryAdd /></MainLayout>} />
                <Route path="productcategory/:id" element={<MainLayout><ProductCategoryAdd /></MainLayout>} />
                <Route path="productcategories" element={<MainLayout><ProductCategorySearch /></MainLayout>} />
                <Route path="product" element={<MainLayout><ProductAdd /></MainLayout>} />
                <Route path="product/:id" element={<MainLayout><ProductAdd /></MainLayout>} />
                <Route path="products" element={<MainLayout><ProductSearch /></MainLayout>} />
                <Route path="deductions" element={<MainLayout><Deductions /></MainLayout>} />
                <Route path="aade/sale" element={<MainLayout><AadeSaleSearchByMark /></MainLayout>} />
                <Route path="postransactions" element={<MainLayout><PosTransactionSearch /></MainLayout>} />
                <Route path="requestpayments" element={<MainLayout><RequestPaymentSearch /></MainLayout>} />
                <Route path="parochosform" element={<MainLayout><ParochosForm /></MainLayout>} />

                

            </Route>

            {/* Catch-all route */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default MainRouter;
